import React from 'react';
import NavMenu from '../Nav/NavMenu';
import Footer from '../footer/Footer';
// import DownloadAppSection from '../global/DownloadAppSection';
// import ContentSlider from '../sliders/ContentSlider';
import EmptySlider from '../sliders/EmptySlider'
import AboutContent from './AboutContent';
import bankTransferImage from "../../assets/static/support.png";


function AboutKontriman() {
  return (
    <div>
      <NavMenu></NavMenu>
      <br></br><br></br>
      <EmptySlider 
        title="Our Story? Personal & Business Banking Made Simple" 
        description="We’re more than a financial institution your trusted partner in growth and long-term success." 
        imageUrl={bankTransferImage}
    />
    {/* 
    content for student account
    
    */}
      <AboutContent></AboutContent>
      <Footer></Footer>
    </div>
  );
}

export default AboutKontriman;
